export default "__VITE_ASSET__CST4llwI__"